export class Budgets {
  public id: number = -1;
  public user_id: number = -1;
  public name: string = '';
  public currency: string = '';
  public currency_format: string = '';
  public date_format: string = '';
  public category_sort_order: string = '';
  public null_budgets: boolean = true;
}